  const container = document.querySelector('.announcement-bar-slider');
  const slides = document.querySelectorAll('.announcement-bar__message');
  let current = 0;

  let startX = 0;
  let startY = 0;
  let isDragging = false;
  let isHorizontalSwipe = false;

  const showSlide = (index, direction = 'left') => {
    if (index === current) return;

    const currentSlide = slides[current];
    const nextSlide = slides[index];

    currentSlide.style.transform = direction === 'left' ? 'translateX(-100%)' : 'translateX(100%)';
    currentSlide.style.opacity = '0';
    currentSlide.setAttribute('aria-hidden', 'true');

    nextSlide.style.transform = direction === 'left' ? 'translateX(100%)' : 'translateX(-100%)';
    nextSlide.style.opacity = '0';
    nextSlide.setAttribute('aria-hidden', 'false');

    void nextSlide.offsetWidth;

    nextSlide.style.transform = 'translateX(0%)';
    nextSlide.style.opacity = '1';

    current = index;
  };

  // Auto-advance every 5s
  let interval = setInterval(() => {
    const nextIndex = (current + 1) % slides.length;
    showSlide(nextIndex, 'left');
  }, 5000);

  // Restart interval after manual interaction
  const resetInterval = () => {
    clearInterval(interval);
    interval = setInterval(() => {
      const nextIndex = (current + 1) % slides.length;
      showSlide(nextIndex, 'left');
    }, 5000);
  };

  // Touch/Mouse Event Handlers
  const onStart = (x, y) => {
    startX = x;
    startY = y;
    isDragging = true;
    isHorizontalSwipe = false;
  };

  const onMove = (x, y, e) => {
    if (!isDragging) return;

    const diffX = x - startX;
    const diffY = y - startY;

    // If it's a horizontal swipe, prevent scrolling
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
      isHorizontalSwipe = true;
      e.preventDefault();
    }
  };

  const onEnd = (x) => {
    if (!isDragging) return;
    const deltaX = x - startX;

    if (Math.abs(deltaX) > 30) {
      if (deltaX < 0) {
        // Swipe/drag left → next
        const nextIndex = (current + 1) % slides.length;
        showSlide(nextIndex, 'left');
      } else {
        // Swipe/drag right → prev
        const prevIndex = (current - 1 + slides.length) % slides.length;
        showSlide(prevIndex, 'right');
      }
      resetInterval();
    }

    isDragging = false;
  };

  // Touch Events
  container.addEventListener('touchstart', (e) => {
    onStart(e.touches[0].clientX, e.touches[0].clientY);
  });

  container.addEventListener('touchmove', (e) => {
    onMove(e.touches[0].clientX, e.touches[0].clientY, e);
  }, { passive: false }); // 👈 required to allow `e.preventDefault()`

  container.addEventListener('touchend', (e) => {
    onEnd(e.changedTouches[0].clientX);
  });

  // Mouse Events (for desktop click + drag)
  container.addEventListener('mousedown', (e) => {
    onStart(e.clientX, e.clientY);
  });

  container.addEventListener('mousemove', (e) => {
    onMove(e.clientX, e.clientY, e);
  });

  container.addEventListener('mouseup', (e) => {
    onEnd(e.clientX);
  });

  // Cleanup if mouse leaves container
  container.addEventListener('mouseleave', () => {
    isDragging = false;
  });